<template>
    <div>
        <b-container fluid>
            <b-row style="margin-bottom: 5px;">
                <b-col cols="auto">
                    查詢起訖時間:
                </b-col>
                <b-col cols="10">
                    <b-input-group style="width: 20vh;display: inline-flex;">
                    <b-input-group-prepend is-text>
                        <b-icon icon="calendar3"></b-icon>
                    </b-input-group-prepend>
                    <datepicker
                        v-model="timepicker.minvalue"
                        style="width: 13vh;"
                        min="1960-01-01"
                        :max="twtimeparse(timepicker.maxvalue)"
                    ></datepicker>
                    </b-input-group>
                    <span style="display: inline-flex; margin-right: 1rem">~</span>
                    <b-input-group
                        style="width: 20vh;display: inline-flex; margin-right: 1rem;"
                    >
                        <b-input-group-prepend is-text>
                        <b-icon icon="calendar3"></b-icon>
                        </b-input-group-prepend>
                        <datepicker
                        v-model="timepicker.maxvalue"
                        style="width: 13vh;"
                        :min="twtimeparse(timepicker.minvalue)"
                        :max="timepicker.max"
                        ></datepicker>
                    </b-input-group>
                    </b-col>
                </b-row>
                <b-row
                    style="margin-bottom: 5px;"
                >
                    <b-col cols="auto">
                    市場作物名稱:
                    </b-col>
                    <b-col cols="10">
                    <v-select
                        style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
                        v-model="fruit.fruitlist.value"
                        :options="fruit.fruitlist.options"
                        
                    ></v-select>
                    <!-- <b-spinner v-show="fruit.fruitlist.items.length==0" style="width: 1.5rem; height: 1.5rem;" variant="success" label="Spinning" /> -->
                    </b-col>
            </b-row>
            <div v-show="fruit.marketlist.options.length > 0">
                <b-row style="margin-bottom: 5px;">
                    <b-col cols="auto">
                        交易市場名稱:
                    </b-col>
                    <b-col cols="10">
                        <b-form-radio-group
                        id="checkbox-group-2"
                        v-show="fruit.marketlist.options.length > 0"
                        v-model="fruit.marketlist.value"
                        :options="fruit.marketlist.options"
                        >
                        </b-form-radio-group>
                    </b-col>
                </b-row>
            </div>
        </b-container>
        <div style="width: 100%;">
        <apexchart
            ref="chart1ref"
            height="450"
            type="line"
            :options="fruit.obj.chart.options"
            :series="fruit.obj.chart.series"
        ></apexchart>
            <!-- <div class="bulletin_div">
                <h1>功能開發中...</h1>
            </div> -->
        </div>
    </div>
</template>
<script>
import datepicker from "@/components/DatepickerForMonth.vue";

export default{
    data(){
        var date = new Date();
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const maxDate = new Date(today);
        // maxDate.setDate(date.getDate() + 1);
        const minDate = new Date(today);
        minDate.setDate(date.getDate() - 365);
        var taiwanMinDate = minDate
        .toLocaleString()
        .split(" ")[0]
        .split("/");
        taiwanMinDate.pop();
        taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
        taiwanMinDate[1] =
        taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
        //taiwanMinDate[2] =
        //taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
        var taiwanMaxDate = maxDate
        .toLocaleString()
        .split(" ")[0]
        .split("/");
        taiwanMaxDate.pop();
        taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
        taiwanMaxDate[1] =
        taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
        //taiwanMaxDate[2] =
        //taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
        return{
            disabled:true,
            taiwanMaxDate,
            timepicker: {
                minvalue: taiwanMinDate.join("-"),
                maxvalue: taiwanMaxDate.join("-"),
                // minvalue: "110-07-12",
                // maxvalue: "110-07-15",
                max: maxDate
                .toLocaleString()
                .split(" ")[0]
                .split("/")
                .join("-"),
                min: minDate
                .toLocaleString()
                .split(" ")[0]
                .split("/")
                .join("-"),
            },
            fruit: {
                fruitlist: {
                value: { label: "請選擇", code: "請選擇", disabled: false },
                options: [],
                items: [],
                BA_items:[],
                },
                marketlist: {
                    value: [],
                    options: [],
                    allitems: [],
                    items: [],
                },
                mainlist: [],
                ifcrop: false,
                iffirst: true,
                ifchartshow: false,
                averageprice: false,
                maintainprice: false,
                overylayshow: true,
                selectlist: [0, "梨子", null],
                typeoptionslist: [
                { text: "請選擇種類", value: null, disabled: true },
                { text: "水果", value: 0 },
                { text: "蔬菜", value: 1 },
                { text: "雜糧特作", value: 2 },
                ],
                options: [
                { text: "請選擇作物", value: null },
                { text: "梨子", value: "梨子" },
                { text: "木瓜", value: "木瓜" },
                { text: "鳳梨", value: "鳳梨" },
                ],
                obj: {
                chart: {
                    series: [],
                    options: {
                    chart: {
                        height: 450,
                        type: "line",
                        zoom: {
                        enabled: false,
                        },
                    },
                    title: {
                        text: "",
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    noData: {
                        text: "請選擇市場作物",
                        align: "center",
                        verticalAlign: "middle",
                    },
                    labels: [],
                    yaxis: [],
                    colors: [
                        "#008FFB",
                        "#19535f",
                        "#FEB019",
                        "#FF4560",
                        "#775DD0",
                        "#1c22ce",
                        "#ff7b3d",
                        "#f9b5c0",
                        "#4c1a11",
                    ],
                    // xaxis: {
                    //   type: "datetime",
                    //   labels: {
                    //     formatter: function(value, timestamp) {
                    //       var date = new Date(timestamp);
                    //       if (date.getFullYear() < 1975) return;
                    //       var year = date.getFullYear() - 1911;
                    //       return (
                    //         year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
                    //       ); // The formatter function overrides format property
                    //     },
                    //   },
                    // },
                    plotOptions: {
                        bar: {
                        columnWidth: "20%",
                        },
                    },
                    grid: {
                        padding: {
                        right: 10,
                        left: 10,
                        },
                    },
                    },
                },
                },
                countryoptions: {
                chart: {
                    height: 350,
                    type: "bar",
                },
                plotOptions: {
                    bar: {
                    horizontal: true,
                    dataLabels: {
                        position: "top",
                    },
                    },
                },
                title: {
                    text: "108年各縣市 種植面積",
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                },
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    categories: [
                    "台中市",
                    "台北市",
                    "台東縣",
                    "台南市",
                    "宜蘭縣",
                    "花蓮縣",
                    "南投縣",
                    "屏東縣",
                    "苗栗縣",
                    "桃園市",
                    "高雄市",
                    "雲林縣",
                    "新北市",
                    "新竹縣",
                    "嘉義縣",
                    "彰化縣",
                    ],
                },
                yaxis: [
                    {
                    title: {
                        text: "各縣市",
                    },
                    },
                ],
                // colors: ['#0000ff', '#8a2be2', '#a52a2a', '#deb887', '#5f9ea0', '#7fff00', '#d2691e', '#ff7f50', '#6495ed', '#dc143c', '#00ffff', '#00008b', '#008b8b', '#b8860b', '#006400', '#8b008b']
                },
                charyioptions: {
                chart: {
                    // height: 350,
                    type: "bar",
                },
                title: {
                    text: "108年嘉義 鄉鎮 種植面積",
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                },
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    categories: [
                    "大林鎮",
                    "中埔鄉",
                    "六腳鄉",
                    "太保市",
                    "水上鄉",
                    "布袋鎮",
                    "民雄鄉",
                    "朴子市",
                    "竹崎鄉",
                    "東石鄉",
                    "大埔鄉",
                    "鹿草鄉",
                    "番路鄉",
                    "新港鄉",
                    "溪口鄉",
                    "義竹鄉",
                    ],
                },
                yaxis: [
                    {
                    title: {
                        text: "種植面積(公頃)",
                    },
                    },
                ],
                },
            },
            apiGetCropForChart: (data) =>
                this.userRequest.post("/API/Default/getCropForMonthChart", data),
            apiGetMyCropFromList: (data) =>
                this.userRequest.post("/API/Default/getMyCropFromList", data),
            apiGetMarketFromCrop: (data) =>
            this.userRequest.post("/API/Default/getMarketFromCropbyMonth", data),
        }
    },
    mounted(){
        //console.log("month mounted")
        this.init();
    },
    watch: {
        "fruit.fruitlist.value"(value) {
        this.getmarketdetial(value.code);
        },
        "timepicker.maxvalue"() {
        if (!this.iffirst)
            // this.updatechart()
            this.init();
        },
        "timepicker.minvalue"() {
        if (!this.iffirst)
            // this.updatechart()
            this.init();
        },
        "fruit.marketlist.value"(value) {
        if (value != "" && value != null) this.optionscheck();
        else this.chartinit();
        },
        "fruit.averageprice"() {
        this.optionscheck();
        },
        "fruit.maintainprice"() {
        this.optionscheck();
        },
    },
    methods:{
        chartinit() {
            this.fruit.obj.chart.series = [];
            this.fruit.obj.chart.options.labels = [];
            this.fruit.obj.chart.options.yaxis = [];
            this.fruit.obj.chart.options.xaxis = {};
        },
        init(){
            this.fruit.fruitlist.items = [];
            this.fruit.fruitlist.options = [];
            this.fruit.marketlist.options = [];
            this.fruit.marketlist.value = [];
            this.fruit.averageprice = false;
            this.fruit.maintainprice = false;
            this.ifloading = true;
            this.chartinit();
            let localmintime = this.timepicker.minvalue.split("-");
            localmintime[0] = parseInt(localmintime[0]) + 1911;
            let localmaxtime = this.timepicker.maxvalue.split("-");
            localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
            // if (this.IsNull(sessionStorage.getItem("Crop")) != "") {
            //     window.setTimeout(() => {
            //     this.$parent.$parent.$parent.mainpage.tabnum = 1;
            //     });
            // }
            let obj = {
                start_date: localmintime.join("-"),
                end_date: localmaxtime.join("-"),
            };
            this.FunctionToken(this.GetMyCropFromList,obj);
        },
        getmarketdetial(value) {
        let localmintime = this.timepicker.minvalue.split("-");
        //localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        //localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

        let diff = Math.floor(
            (Date.parse(localmaxtime.join("-")) -
            Date.parse(localmintime.join("-"))) /
            86400000
        );

        if (value != "請選擇") {
            if (diff > 366) {
            alert("時間選擇區間不能超過1個月");
            } else {
            this.ifloading = true;
            let obj = {
                start_month: localmintime.join("."),
                end_month: localmaxtime.join("."),
                CROP_CODE: value,
            };
            this.FunctionToken(this.getMarketFromCrop, obj);
            }
        }
        },
        getchartdata() {
        if (
            this.fruit.marketlist.value != "" &&
            this.fruit.fruitlist.value.code != "請選擇"
        ) {
            this.ifloading = true;
            let localmintime = this.timepicker.minvalue.split("-");
            //localmintime[0] = parseInt(localmintime[0]) + 1911;
            let localmaxtime = this.timepicker.maxvalue.split("-");
            //localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

            let obj = {};

            if (this.fruit.marketlist.value == "全國") {
            let optionlist = [];

            this.fruit.marketlist.options.forEach((x) => {
                optionlist.push(x.value);
            });

            obj = {
                start_month: localmintime.join("."),
                end_month: localmaxtime.join("."),
                CROP_CODE: this.fruit.fruitlist.value.code,
                MARKET_CODE: optionlist,
            };
            } else {
            obj = {
                start_month: localmintime.join("."),
                end_month: localmaxtime.join("."),
                CROP_CODE: this.fruit.fruitlist.value.code,
                MARKET_CODE: [this.fruit.marketlist.value],
            };
            }

            this.FunctionToken(this.getCropForChart, obj);
        }
        },
        twtimeparse(item) {
        let tt = item.split("-");
        tt[0] = parseInt(tt[0]) + 1911;
        return tt.join("-");
        },
        optionscheck() {
            this.getchartdata();
        },
        createnewchart() {
            this.fruit.obj.chart.series = [];
            this.fruit.obj.chart.options.labels = [];
            this.fruit.obj.chart.options.yaxis = [];
            let datelist = [];
            let mainlist = [];
            let serieslist = [];

            for (let j in this.fruit.fruitlist.items) {
                let subitem10 = this.fruit.fruitlist.items[j].MONTH.split(".");
                let subdate10 = subitem10[0] + "/" + subitem10[1];
                if (datelist.indexOf(subdate10) == -1) {
                datelist.push(subdate10);
                }
            }

            let list1 = [];
            if (this.fruit.marketlist.value == "全國") {
                for (let i in datelist) {
                let subtime = datelist[i];
                let allavgprice = 0,
                    allvolume = 0,
                    count1 = 0,
                    count2 = 0;
                for (let j in this.fruit.fruitlist.items) {
                    let subitem2 = this.fruit.fruitlist.items[j];
                    let subdate2 = subitem2.MONTH.split(".");
                    let subtime2 = subdate2[0] + "/" + subdate2[1];
                    if (subtime2 == subtime) {
                    if (subitem2.PRICE_AVG != 0) {
                        allavgprice = allavgprice + subitem2.PRICE_AVG;
                        count1++;
                    }
                    if (subitem2.VOLUME != 0) {
                        allvolume = allvolume + subitem2.VOLUME;
                        count2++;
                    }
                    }
                }
                let avgvalue1 = 0,
                    volumevalue1 = 0;
                if (count1 != 0) avgvalue1 = Math.round(allavgprice / count1);
                if (count2 != 0) volumevalue1 = Math.round(allvolume / count2);

                let obj1 = {
                    date: subtime,
                    avgprice: avgvalue1,
                    volume: volumevalue1,
                };
                list1.push(obj1);
                }
                let obj2 = { name: "全國", data: list1 };
                mainlist.push(obj2);
            } else {
                let marketindex = this.fruit.marketlist.options.findIndex(
                (x) => x.value == this.fruit.marketlist.value
                );
                let subitem1 = this.fruit.marketlist.options[marketindex].text;
                for (let z in this.fruit.fruitlist.items) {
                let fruititem = this.fruit.fruitlist.items[z];
                if (fruititem.MARKET == subitem1) {
                    let fruitItemDate = fruititem.MONTH.split(".");
                    let fruitSubdate = fruitItemDate[0] + "/" + fruitItemDate[1];
                    let obj1 = {
                    date: fruitSubdate,
                    avgprice: fruititem.PRICE_AVG.toFixed(2),
                    volume: fruititem.VOLUME.toFixed(2),
                    };
                    list1.push(obj1);
                }
                }
                let obj2 = { name: subitem1, data: list1 };
                mainlist.push(obj2);
            }

            for (let k in mainlist) {
                let element1 = mainlist[k];
                let avglist = [],
                volumelist = [];

                for (let t in datelist) {
                let subdate = datelist[t];
                let subindex = element1.data.findIndex((y) => y.date == subdate);
                if (subindex != -1) {
                    let element2 = element1.data[subindex];
                    avglist.push(element2.avgprice);
                    volumelist.push(element2.volume);
                } else {
                    avglist.push(0);
                    volumelist.push(0);
                }
                }

                let volumeobj = {
                name: element1.name + "交易均量",
                type: "column",
                data: volumelist,
                };

                serieslist.push(volumeobj);

                let avgobj = {
                name: element1.name + "拍賣均價",
                type: "line",
                data: avglist,
                };

                serieslist.push(avgobj);

                let volumeoption = {},
                avgoption = {};
                if (k == 0) {
                volumeoption = {
                    seriesName: "交易均量",
                    title: {
                    text: "交易均量(公斤)",
                    },
                };

                avgoption = {
                    seriesName: "拍賣均價",
                    opposite: true,
                    title: {
                    text: "價格 ( 元 / 公斤 )",
                    },
                };
                } else {
                volumeoption = {
                    seriesName: "交易均量",
                    show: false,
                };

                avgoption = {
                    seriesName: "拍賣均價",
                    show: false,
                };
                }

                this.fruit.obj.chart.options.yaxis.push(volumeoption);
                this.fruit.obj.chart.options.yaxis.push(avgoption);
            }

            if (this.fruit.averageprice || this.fruit.maintainprice) {
                let averagelist2 = [],
                mantainlist2 = [];
                for (let l in datelist) {
                let averagelist3 = [],
                    mantainlist3 = [],
                    datelist3 = [];
                let dateelement = datelist[l];
                for (let n in this.fruit.fruitlist.items) {
                    let subitem5 = this.fruit.fruitlist.items[n];
                    let subdate5 = subitem5.MONTH.split(".");
                    let subtime5 = subdate5[0] + "/" + subdate5[1];
                    if (
                    datelist3.indexOf(subtime5) == -1 &&
                    subtime5 == dateelement &&
                    subitem5.CROP_CODE == this.fruit.fruitlist.value.code
                    ) {
                    if (this.fruit.averageprice) {
                        let avgprice =
                        (subitem5.CM_PRICE_C +
                            subitem5.CM_PRICE_M +
                            subitem5.CM_PRICE_F) /
                        3;
                        averagelist3.push(avgprice);
                    }

                    if (this.fruit.maintainprice) {
                        mantainlist3.push(subitem5.CM_PRICE_MON);
                    }
                    datelist3.push(subtime5);
                    }
                }
                let avg2 = 0,
                    volume2 = 0,
                    avgcounter = 0,
                    volumecounter = 0;

                if (this.fruit.averageprice) {
                    averagelist3.forEach((y) => {
                    if (y != 0) avgcounter++;
                    avg2 += y;
                    });
                    if (avgcounter != 0) {
                    let value1 = avg2 / avgcounter;
                    averagelist2.push(value1.toFixed(2));
                    } else {
                    averagelist2.push(0);
                    }
                }
                if (this.fruit.maintainprice) {
                    mantainlist3.forEach((z) => {
                    if (z != 0) volumecounter++;
                    volume2 += z;
                    });
                    if (volumecounter != 0) {
                    let value2 = volume2 / volumecounter;
                    mantainlist2.push(value2.toFixed(2));
                    } else {
                    mantainlist2.push(0);
                    }
                }
                }

                if (averagelist2.length > 0) {
                let obj = {
                    name: "嘉義縣產地均價",
                    type: "line",
                    data: averagelist2,
                };
                serieslist.push(obj);

                if (this.fruit.obj.chart.options.yaxis.length == 0) {
                    let chartoption = {
                    seriesName: "拍賣均價",
                    opposite: true,
                    title: {
                        text: "價格 ( 元 / 公斤 )",
                    },
                    };
                    this.fruit.obj.chart.options.yaxis.push(chartoption);
                } else {
                    let chartoption = {
                    seriesName: "拍賣均價",
                    show: false,
                    };
                    this.fruit.obj.chart.options.yaxis.push(chartoption);
                }
                }

                if (mantainlist2.length > 0) {
                let obj = {
                    name: "農糧署產地價格監控",
                    type: "line",
                    data: mantainlist2,
                };
                serieslist.push(obj);

                if (this.fruit.obj.chart.options.yaxis.length == 0) {
                    let chartoption = {
                    seriesName: "拍賣均價",
                    opposite: true,
                    title: {
                        text: "價格 ( 元 / 公斤 )",
                    },
                    };
                    this.fruit.obj.chart.options.yaxis.push(chartoption);
                } else {
                    let chartoption = {
                    seriesName: "拍賣均價",
                    show: false,
                    };
                    this.fruit.obj.chart.options.yaxis.push(chartoption);
                }
                }
            }

            this.fruit.obj.chart.series = serieslist;
            this.fruit.obj.chart.options.labels = datelist;

            this.parseSpecificStingToDashed();

            this.ifloading = false;
            if (this.$refs.chart1ref != undefined) {
                this.$refs.chart1ref.updateSeries(this.fruit.obj.chart.series);
                this.$refs.chart1ref.updateOptions(this.fruit.obj.chart.options);
            }
        },
        getCropForChart(data) {
        this.apiGetCropForChart(data)
            .then((res) => {
            const json = JSON.parse(res.data);
            if (json.Status) {
                this.fruit.fruitlist.items = JSON.parse(json.Data);
                this.createnewchart();
            }
            })
            .catch((err) => console.warn(err));
        },
        getMarketFromCrop(data) {
        this.apiGetMarketFromCrop(data)
            .then((res) => {
            const json = JSON.parse(res.data);
            if (json.Status) {
                let arr = JSON.parse(json.Data);
                this.fruit.marketlist.options = [];
                this.fruit.marketlist.value = [];
                this.fruit.averageprice = false;
                this.fruit.maintainprice = false;
                arr.forEach((x) => {
                let obj = {
                    text: x.MARKET,
                    value: x.MARKET_CODE,
                };
                this.fruit.marketlist.options.push(obj);
                });
                let obj = {
                text: "全國",
                value: "全國",
                };
                this.fruit.marketlist.options.unshift(obj);
                this.ifloading = false;
            }
            })
            .catch((err) => console.warn(err));
        },
        GetMyCropFromList(data){
        this.apiGetMyCropFromList(data)
            .then((res)=>{
                let data =  JSON.parse(res.data);
                if(data.Status){
                    let  jsondata = JSON.parse(data.Data);
                    jsondata.forEach((x) => {
                    let obj = {
                        label: x.CROP,
                        code: x.CROP_CODE,
                        disabled: true,
                    };
                        this.fruit.fruitlist.items.push(obj);
                    });
                    this.fruit.fruitlist.options = this.fruit.fruitlist.items.slice(0);
                    this.fruit.fruitlist.options.unshift({
                        label: "請選擇",
                        code: "請選擇",
                        disabled: false,
                    });
                    this.fruit.fruitlist.value = {
                        label: "請選擇",
                        code: "請選擇",
                        disabled: false,
                    };
                    //console.log("this.fruit.fruitlist.options",this.fruit.fruitlist);
                }
            })
    },
    parseSpecificStingToDashed() {
        let num = this.fruit.obj.chart.series.length;
        this.fruit.obj.chart.options.stroke = {
            show: true,
            width: new Array(num).fill(2),
            curve: "straight",
            dashArray: new Array(num).fill(0),
        };
        this.fruit.obj.chart.options.colors = [
            "#33a5fb",
            "#775dd0",
            "#1c22ce",
            "#ff7b3d",
            "#f9b5c0",
            "#4c1a11",
            "#6f5c5d",
            "#88715c",
            "#86a3be",
        ];

        let index1 = this.fruit.obj.chart.series.findIndex(
            (x) => x.name == "全國拍賣均價"
        );
        let index2 = this.fruit.obj.chart.series.findIndex(
            (x) => x.name == "嘉義縣產地均價"
        );
        let index3 = this.fruit.obj.chart.series.findIndex(
            (x) => x.name == "農糧署產地價格監控"
        );

        if (index1 != -1 || index2 != -1 || index3 != -1) {
            if (index1 != -1)
            this.fruit.obj.chart.options.stroke.dashArray[index1] = 15;
            this.fruit.obj.chart.options.colors[index1] = "#19535f";
            if (index2 != -1)
            this.fruit.obj.chart.options.stroke.dashArray[index2] = 35;
            this.fruit.obj.chart.options.colors[index2] = "#feb019";
            if (index3 != -1)
            this.fruit.obj.chart.options.colors[index3] = "#ff4560";
        }
        console.log([
            index1,
            index2,
            index3,
            this.fruit.obj.chart.options.stroke,
            this.fruit.obj.chart.options.colors,
            this.fruit.obj.chart.series,
        ]);   
    },
    getnewdate(date, index) {
        let firstdate = date.split("-");
        firstdate[0] = parseInt(firstdate[0]) + 1911;
        let subdate = new Date(firstdate.join("-"));
        if (index == 0) {
            subdate.setDate(subdate.getDate() - 1);
        } else {
            subdate.setDate(subdate.getDate() + 1);
        }
        let formatDate =
            parseInt(subdate.getFullYear()) -
            1911 +
            "-" +
            (subdate.getMonth() + 1) +
            "-" +
            subdate.getDate();
        return formatDate;    
    },
    getnewdate2(date) {
        let datelist = [];
        date.forEach((x) => {
            let date = x.split("-");
            date[0] = parseInt(date[0]) - 1911;
            datelist.push(date.join("/"));
        });
        return datelist;
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
        const weekday = date.getDay();
        // Return `true` if the date should be disabled
        return weekday === 0 || weekday === 6;
    },
    },
    components: {
        datepicker,
    },
}
</script>
<style scoped>
    .bulletin_div{
        width: 100%;
        background-color: rgb(159, 156, 156,0.9);
        border-radius: 5px;
        border: 0;
        min-height: 500px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>